<template>
  <div>
    <NavBar />
    <div class="container-fluid">
      <div class="text-right">
        <v-btn
          v-if="permissions.standard_medicine.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus mr-1"></span> NOVO MEDICAMENTO
        </v-btn>
      </div>
      <b-modal size="xl" id="createMedicine" hide-footer no-close-on-backdrop>
        <template v-slot:modal-title>NOVO MEDICAMENTO</template>
        <div class="d-block">
          <div class="container">
            <form v-on:submit="create" method="post">
              <div class="row">
                <div class="col-md-12 pt-0 pb-0">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                </div>
                <div class="col-md-8 pt-0 pb-0">
                  <LabelRequiredField label="NOME COMERCIAL" />
                  <input type="text" v-model="name" class="form-control" />
                </div>
                <div class="col-md-4 pt-0 pb-0">
                  <label>APRESENTAÇÃO</label>
                  <input
                    type="text"
                    v-model="presentation"
                    class="form-control"
                  />
                </div>
                <div class="col-md-12 pt-0 pb-0">
                  <LabelRequiredField label="PRINCÍPIO ATIVO" />
                  <select v-model="active_ingredient_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in active_ingredient"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4 pt-0 pb-0">
                  <LabelRequiredField label="UNIDADE DE MEDIDA" />
                  <select v-model="unit_of_measurement_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in unitOfMeasurements"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4 pt-0 pb-0">
                  <label>CLASSE TERAPÊUTICA</label>
                  <input
                    type="text"
                    v-model="therapeutic_class"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4 pt-0 pb-0">
                  <LabelRequiredField label="TIPO DE RECEITA" />
                  <select v-model="type_of_recipe_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in typesOfRecipe"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4 pt-0 pb-0">
                  <label>TIPO DE MEDICAMENTO</label>
                  <select v-model="type_of_medicine_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in typesOfMedicine"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 pt-0 pb-0 text-right">
                  <v-btn
                    :disabled="loadingCreate"
                    type="submit"
                    class="v-success"
                  >
                    <span class="fa fa-check mr-1"></span>
                    {{ loadingCreate ? "CARREGANDO" : "SALVAR" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-modal>
      <v-card>
        <v-card-title>
          MEDICAMENTOS PADRÕES
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            @input="paginate"
          />
        </v-card-title>
        <b-overlay :show="loadingMedicine" opacity="0.99">
          <v-data-table
            dense
            :headers="headers"
            :items="medicines"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :options.sync="options"
            :server-items-length="total"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <b-modal
                size="xl"
                :id="`medicine_${String(item.id)}`"
                hide-footer
                no-close-on-backdrop
              >
                <template v-slot:modal-title>EDITAR MEDICAMENTO</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay :show="loadingMedicineUpdate" opacity="0.99">
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <div class="col-md-12 pt-0 pb-0">
                            <WarningRequiredFields />
                            <ErrorsMessages :errors="errors" />
                          </div>
                          <div class="col-md-8 pt-0 pb-0">
                            <LabelRequiredField label="NOME COMERCIAL" />
                            <input
                              :disabled="!permissions.standard_medicine.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-4 pt-0 pb-0">
                            <label>APRESENTAÇÃO</label>
                            <input
                              type="text"
                              v-model="presentation"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12 pt-0 pb-0">
                            <LabelRequiredField label="PRINCÍPIO ATIVO" />
                            <select
                              v-model="active_ingredient_id"
                              class="form-control"
                            >
                              <option value>SELECIONE...</option>
                              <option
                                v-for="value in active_ingredient"
                                :key="value.id"
                                :value="value.id"
                              >
                                {{ value.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4 pt-0 pb-0">
                            <LabelRequiredField label="UNIDADE DE MEDIDA" />
                            <select
                              :disabled="!permissions.standard_medicine.edit"
                              v-model="unit_of_measurement_id"
                              class="form-control"
                            >
                              <option
                                v-for="value in unitOfMeasurements"
                                :key="value.id"
                                :value="value.id"
                              >
                                {{ value.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4 pt-0 pb-0">
                            <label>CLASSE TERAPÊUTICA</label>
                            <input
                              :disabled="!permissions.standard_medicine.edit"
                              type="text"
                              v-model="therapeutic_class"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-4 pt-0 pb-0">
                            <LabelRequiredField label="TIPO DE RECEITA" />
                            <select
                              :disabled="!permissions.standard_medicine.edit"
                              v-model="type_of_recipe_id"
                              class="form-control"
                            >
                              <option
                                v-for="value in typesOfRecipe"
                                :key="value.id"
                                :value="value.id"
                              >
                                {{ value.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4 pt-0 pb-0">
                            <label>TIPO DE MEDICAMENTO</label>
                            <select
                              :disabled="!permissions.standard_medicine.edit"
                              v-model="type_of_medicine_id"
                              class="form-control"
                            >
                              <option :value="null">SELECIONE...</option>
                              <option
                                v-for="value in typesOfMedicine"
                                :key="value.id"
                                :value="value.id"
                              >
                                {{ value.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-12 pb-0 d-flex align-items-center">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6 class="ml-2">
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 pt-0 pb-0 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="
                                $bvModal.hide(`medicine_${String(item.id)}`)
                              "
                            >
                              <span class="fa fa-arrow-left mr-1"></span> VOLTAR
                            </v-btn>
                            <v-btn
                              v-if="permissions.standard_medicine.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success"
                            >
                              <span class="fa fa-check mr-1"></span>
                              {{ loadingUpdate ? "CARREGANDO" : "SALVAR" }}
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
            </template>
          </v-data-table>
        </b-overlay>
      </v-card>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import api from "../services/api";
import NavBar from "../templates/NavBar";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Medicine",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      total: 0,
      options: {},
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "NOME COMERCIAL", value: "name", sortable: false },
        {
          text: "PRINCÍPIO ATIVO",
          value: "active_ingredient",
          sortable: false,
        },
        {
          text: "TIPO DE RECEITA",
          value: "type_of_recipe_name",
          sortable: false,
        },
        {
          text: "UNIDADE DE MEDIDA",
          value: "unit_of_measurement_abbreviation",
          sortable: false,
        },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      medicines: [],
      unitOfMeasurements: [],
      typesOfMedicine: [],
      typesOfRecipe: [],
      active_ingredient: [],
      unit_of_measurement_id: "",
      id: "",
      type_of_medicine_id: "",
      type_of_recipe_id: "",
      active_ingredient_id: "",
      name: "",
      presentation: "",
      therapeutic_class: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingMedicineUpdate: false,
      loadingMedicine: true,
    };
  },
  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];

      this.id = item.id;
      this.unit_of_measurement_id = item.unit_of_measurement_id;
      this.type_of_medicine_id = item.type_of_medicine_id;
      this.type_of_recipe_id = item.type_of_recipe_id;
      this.active_ingredient_id = item.active_ingredient_id;
      this.name = item.name;
      this.presentation = item.presentation;
      this.therapeutic_class = item.therapeutic_class;

      this.$bvModal.show(`medicine_${String(item.id)}`);
    },
    retrieve() {
      this.permissions = adminData().permissions;

      this.getUnitOfMeasurements();
      this.getTypesOfMedicine();
      this.getTypesOfRecipe();
      this.getActiveIngredients();
    },
    async paginate() {
      try {
        this.loadingMedicine = true;

        const { search } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          page,
          itemsPerPage,
          search,
        };

        const response = await api.get("/admin/standard/medicine/paginate", {
          params,
        });

        const { medicines, total } = response.data;

        this.medicines = medicines;
        this.total = total;
        this.loadingMedicine = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/admin/unit-of-measurement/all");

        const { unit_of_measurement } = response.data;

        this.unitOfMeasurements = unit_of_measurement;
      } catch (error) {
        console.log(error);
      }
    },
    async getTypesOfMedicine() {
      try {
        const response = await api.get("/admin/type-of-medicine/all");

        const { types } = response.data;

        this.typesOfMedicine = types;
      } catch (error) {
        console.log(error);
      }
    },
    async getTypesOfRecipe() {
      try {
        const response = await api.get("/admin/type-of-recipe/all");

        const { types } = response.data;

        this.typesOfRecipe = types;
      } catch (error) {
        console.log(error);
      }
    },
    async getActiveIngredients() {
      try {
        const response = await api.get("/admin/active-ingredient");

        const { active_ingredient } = response.data;

        this.active_ingredient = active_ingredient;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const {
          unit_of_measurement_id,
          type_of_medicine_id,
          type_of_recipe_id,
          active_ingredient_id,
          name,
          presentation,
          therapeutic_class,
        } = this;

        let params = {
          unit_of_measurement_id,
          type_of_medicine_id,
          type_of_recipe_id,
          active_ingredient_id,
          name,
          presentation,
          therapeutic_class,
        };

        const response = await api.post(
          "/admin/standard/medicine/create",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("createMedicine");
          this.errors = [];
          this.paginate();
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.unit_of_measurement_id = "";
      this.type_of_medicine_id = "";
      this.type_of_recipe_id = "";
      this.active_ingredient_id = "";
      this.name = "";
      this.presentation = "";
      this.therapeutic_class = "";
      this.$bvModal.show("createMedicine");
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const {
          id,
          unit_of_measurement_id,
          type_of_medicine_id,
          type_of_recipe_id,
          active_ingredient_id,
          name,
          presentation,
          therapeutic_class,
        } = this;

        let params = {
          id,
          unit_of_measurement_id,
          type_of_medicine_id,
          type_of_recipe_id,
          active_ingredient_id,
          name,
          presentation,
          therapeutic_class,
        };

        const response = await api.put(
          "/admin/standard/medicine/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`medicine_${String(id)}`);
          this.paginate();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>